import { render, staticRenderFns } from "./recommendHouse_university.vue?vue&type=template&id=3a73853e&scoped=true"
import script from "./recommendHouse_university.vue?vue&type=script&lang=js"
export * from "./recommendHouse_university.vue?vue&type=script&lang=js"
import style0 from "./recommendHouse_university.vue?vue&type=style&index=0&id=3a73853e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73853e",
  null
  
)

export default component.exports